<nav
  id="maincontent_navbar"
  class="navbarMain navbar navbar-default navbar-fixed-top"
  aria-label="Main navigation"
  *ngIf="!states.detached && !states.mapDetach && !showDisclaimer">
<div class="navbar-header-group container-fluid">

 <!--// Navbar, main navigation menu section -->
 <div class="navbar-header">
  <span class="navbar-brand-group">
      <!-- Logo image is defined in CSS -->
	  <button *ngIf="!states.detached && !states.mapDetach"
	     (click)="goHome()"
	     class="navbar-brand btn btn-link"
	     title="{{LOCALIZATION.logoMain}}"
	     aria-label="Home">
	  </button>
		<!-- Optional branding text is defined in CSS -->
		<!-- Show a clickable span only if the URL exists in feature configuration -->
		<ng-container *ngIf="isFeatureEnabled('BrandUrl'); else plainSpan">
		  <span class="navbar-brand-copy-text pointMe" (click)="openUrl(getBrandURL())" role="link" tabindex="0"></span>
		</ng-container>
		<ng-template #plainSpan>
		  <span class="navbar-brand-copy-text"></span>
		</ng-template>
  </span>
  <ul *ngIf="!userPermissions?.['BLOCK_NAV_BAR']" class="navbar-main-menu customNav" role="menu">
    <li [ngStyle]="{ visibility: !isUserAllowedToSearch ? 'hidden' : 'visible' }" role="menuitem">
      <a routerLink="/s"
      	 routerLinkActive="active"
      	 (click)="goToMode('s')">
      	 	<i class="visible-xs fas fa-search nav-icon"></i><span class="hidden-xs">{{ LOCALIZATION.search }}</span>
      </a>
    </li>
    
    <li *ngIf="user?.loggedin && upload" class="hidden-xs" role="menuitem">
      <a routerLink="/upload"
    	 routerLinkActive="active"
    	 (click)="goToMode('upload')">
    	 	<span>{{ LOCALIZATION.upload }}</span>
      </a>
    </li>

    <li *ngIf="orderOn" class="hidden-xs" role="menuitem">
      <a routerLink="/downloads"
    	 routerLinkActive="active"
    	 (click)="goToMode('downloads')">
    	 	<span>{{ LOCALIZATION.exportsDownloads }}</span>
      </a>
    </li>    

    <li class="hidden-xs"
        *ngIf="user?.loggedin && (userPermissions?.['ROLE_NOTIFICATION_CREATE'] || userPermissions?.['ROLE_NOTIFICATION_MANAGEMENT'] || userPermissions?.['ROLE_NOTIFICATION_SUBSCRIBE'] || userPermissions?.['ROLE_NOTIFICATION_VIEW'])"
        role="menuitem">
      <a routerLink="/saved-searches"
         routerLinkActive="active"
         (click)="goToMode('saved-searches')">
         	<span>{{ LOCALIZATION.savedSearches }}</span>
      </a>
    </li>

    <li class="hidden-xs" 
    	*ngIf="user?.loggedin && albumOn"
    	role="menuitem">
      <a routerLink="/albums"
    	 routerLinkActive="active"
    	 (click)="goToMode('albums')">
    	 	<span>{{ LOCALIZATION.albums }}</span>
      </a>
    </li>

    <li class="hidden-xs" *ngIf="cartOn" role="menuitem">
      <a routerLink="/cart"
    	 routerLinkActive="active"
    	 (click)="goToMode('cart')">
    	 	<span>{{ LOCALIZATION.cart }}</span>
      </a>
    </li>

    <li class="hidden-xs" 
    	*ngIf="user?.loggedin && downloadOn"
    	role="menuitem">
      <a routerLink="/purchases"
    	 routerLinkActive="active"
    	 (click)="goToMode('purchases')">
    	 	<span>{{ LOCALIZATION.purchases }}</span>
      </a>
    </li>

    <li class="hidden-xs"
        *ngIf="dxOn && user?.loggedin && (userPermissions?.['ROLE_DECLASS_BATCH_VIEW'] || userPermissions?.['ROLE_DECLASS_BATCH_MANAGE'] || userPermissions?.['ROLE_DECLASS_TASK_VIEW'] || userPermissions?.['ROLE_DECLASS_TASK_MANAGE'])"
        role="menuitem">
      <a routerLink="/dx"
         routerLinkActive="active"
         (click)="goToMode('dx')">
         	<span>{{ LOCALIZATION.awdx }}</span>
      </a>
    </li>
  </ul>
 </div>
 
 <!--// Navbar, non-navigation menu section -->
 <div *ngIf="!states.detached && !states.mapDetach" id="navbar" class="navbar-right-menu">
 
 	<!--// Social icons display -->
 	<ng-container
		*ngIf="(
		    socials?.x?.length > 0 ||
		    socials?.facebook?.length > 0 ||
		    socials?.youtube?.length > 0 ||
		    socials?.instagram?.length > 0 ||
		    socials?.linkedin?.length > 0)">
	 	<!--// Socials expanded display -->
	 	<ul class="social-icon-nav hidden-sm hidden-xs">
			<li class='icon-container social-icons'>
	           <a *ngIf="socials?.x?.length > 0" target="_blank" [href]="socials.x" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkTwitter">
	               <i class="social-icon nav-icon fa-brands fa-x-twitter" aria-hidden="true"></i>
	           </a>
	           <a *ngIf="socials?.facebook?.length > 0" target="_blank" [href]="socials.facebook" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkFacebook">
	               <i class="social-icon nav-icon fa-brands fa-facebook" aria-hidden="true"></i>
	           </a>
	           <a *ngIf="socials?.youtube?.length > 0" target="_blank" [href]="socials.youtube" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkYoutube">
	               <i class="social-icon nav-icon fa-brands fa-youtube" aria-hidden="true"></i>
	           </a>
	           <a *ngIf="socials?.instagram?.length > 0" target="_blank" [href]="socials.instagram" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkInstagram">
	               <i class="social-icon nav-icon fa-brands fa-instagram" aria-hidden="true"></i>
	           </a>
	           <a *ngIf="socials?.linkedin?.length > 0" target="_blank" [href]="socials.linkedin" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkLinkedin">
	               <i class="social-icon nav-icon fa-brands fa-linkedin" aria-hidden="true"></i>
	           </a>
	        </li>			  
		</ul>
		
		<!--// Socials collapsed menu -->
		<ul class="social-dropdown customNav visible-sm"> 
		  <li class="dropdown" ngbDropdown #dropdownRef="ngbDropdown" autoClose="outside">
			<button
			  type="button"
			  ngbDropdownToggle
			  id="social-menu-button"
			  class="btn btn-link dropdown-toggle"
			  aria-expanded="false"
			  aria-haspopup="true"
			  title="{{ LOCALIZATION.socialLinks }}"
			  [attr.aria-label]="LOCALIZATION.socialLinks">
		      	<i class="nav-icon fa fa-share-alt"></i>
		    </button>
		    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop nav-alerts" aria-labelledby="social-menu-button" role="menu">
		      <div class="custom-drop-panel">
		        <div class="icon-container social-icons">
		           <a *ngIf="socials?.x?.length > 0" target="_blank" [href]="socials.x" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkTwitter">
		               <i class="social-icon nav-icon fa-brands fa-x-twitter" aria-hidden="true"></i>
		           </a>
		           <a *ngIf="socials?.facebook?.length > 0" target="_blank" [href]="socials.facebook" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkFacebook">
		               <i class="social-icon nav-icon fa-brands fa-facebook" aria-hidden="true"></i>
		           </a>
		           <a *ngIf="socials?.youtube?.length > 0" target="_blank" [href]="socials.youtube" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkYoutube">
		               <i class="social-icon nav-icon fa-brands fa-youtube" aria-hidden="true"></i>
		           </a>
		           <a *ngIf="socials?.instagram?.length > 0" target="_blank" [href]="socials.instagram" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkInstagram">
		               <i class="social-icon nav-icon fa-brands fa-instagram" aria-hidden="true"></i>
		           </a>
		           <a *ngIf="socials?.linkedin?.length > 0" target="_blank" [href]="socials.linkedin" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkLinkedin">
		               <i class="social-icon nav-icon fa-brands fa-linkedin" aria-hidden="true"></i>
		           </a>	        
		        </div>
		      </div>
		    </ul>
		  </li>
	    </ul>
	</ng-container>    
    
    <!--// Alerts menu -->
	<ul class="user-alerts customNav" *ngIf="user?.loggedin">
	  <li class="dropdown" ngbDropdown autoClose="outside">
		<button
		  type="button"
		  id="alerts-menu-button"
		  ngbDropdownToggle
		  class="btn btn-link dropdown-toggle"
		  aria-expanded="false"
		  aria-haspopup="true"
		  [attr.aria-label]="LOCALIZATION.alerts"
		  title="{{ LOCALIZATION.alerts }}"
		  (click)="closeLiveAlerts()">
		      <span
		        *ngIf="alerts.length > 0"
		        class="badge"
		        style="position: absolute; top: 8px; right: 0; font-weight: normal;">
		        {{ alerts.length }}
		      </span>
		      <i class="nav-icon fa fa-bell"></i>
	    </button>
	    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop nav-alerts" aria-labelledby="alerts-menu-button" role="menu">
	      <div class="custom-drop-panel">
	        <div class="list-group">
	          <ng-container *ngIf="alertsView && alertsView.length > 0">
	          <div
	            class="list-group-item pointMe"
	            *ngFor="let alert of alertsView?.slice(0, 7); index as i"
	            (click)="$event.stopPropagation(); showAlert(i)">
	            <div class="row alert-{{ alert.status }} alert-label">
	              <div class="col-xs-10">{{ alert.title }}</div>
	              <div class="col-xs-2">
	                <i class="fa fa-times fa-1x text-{{ alert.status }} pointMe pull-right"
	                   aria-hidden="true"
	                   (click)="$event.stopPropagation(); closeAlert(i)"></i>
	              </div>
	            </div>
	            <div class="row">
	              <div
	                class="col-xs-12"
	                [ngClass]="{ truncate: !alert.show }"
	                (click)="alert.action?.action(alert.action?.arg)"
	                style="word-wrap: break-word">
	                {{ alert.message }}
	              </div>
	            </div>
	            <div class="row text-small">
	              <div
	                class="col-xs-12"
	                [ngClass]="{ truncate: !alert.show }"
	                style="word-wrap: break-word">
	                {{ alert.date }}
	              </div>
	            </div>
	          </div>
	          </ng-container> 
	          <div class="list-group-item" *ngIf="!alertsView || alertsView.length < 1">
	            <em>{{ LOCALIZATION.alertsEmpty }}</em>
	          </div>
	          <div
	            class="list-group-item"
	            [ngClass]="{ 'btn-group-vertical': isMobile }"
	            *ngIf="alerts && alerts.length > 0">
	            <button
	              class="btn btn-default"
	              [ngStyle]="alertsMode === 'success' ? { 'background-color': '#dff0d8' } : { 'background-color': 'revert' }"
	              type="button"
	              (click)="$event.stopPropagation(); toggleAlertMode('success')">
	             	 {{ LOCALIZATION.alertSuccess }}
	            </button>
	            <button
	              class="btn btn-default"
	              [ngStyle]="alertsMode === 'info' ? { 'background-color': '#d9edf7' } : { 'background-color': 'revert' }"
	              (click)="$event.stopPropagation(); toggleAlertMode('info')">
	              	{{ LOCALIZATION.alertInfo }}
	            </button>
	            <button
	              class="btn btn-default"
	              [ngStyle]="alertsMode === 'danger' ? { 'background-color': '#f2dede' } : { 'background-color': 'revert' }"
	              (click)="$event.stopPropagation(); toggleAlertMode('danger')">
	              	{{ LOCALIZATION.alertError }}
	            </button>
	          </div>
	          <div class="list-group-item" *ngIf="alerts && alerts.length > 0">
	            <button class="btn btn-primary" (click)="$event.stopPropagation(); showAllAlerts()">
	              {{ LOCALIZATION.showAllAlerts }}
	            </button>
	            <button class="btn btn-primary" (click)="$event.stopPropagation(); clearAlerts()">
	              {{ LOCALIZATION.clearAlerts }}
	            </button>
	          </div>
	        </div>
	      </div>
	    </ul>
	  </li>
	</ul>
	
	<!--// Messages menu -->
	<ul class="user-messages hidden-xs customNav" *ngIf="user?.loggedin">
	  <li class="dropdown" ngbDropdown #dropdownRef="ngbDropdown" autoClose="outside">
		<button
		  type="button"
		  id="messages-menu-button"
		  ngbDropdownToggle
		  class="btn btn-link dropdown-toggle"
		  aria-expanded="false"
		  aria-haspopup="true"
		  [attr.aria-label]="LOCALIZATION.messages"
		  title="{{ LOCALIZATION.messages }}"
		  (click)="closeLiveAlerts(); displayMessages()">
		      <span
		        *ngIf="messagesCount"
		        class="badge"
		        [innerText]="messagesCount"
		        style="position: absolute; top: 8px; right: 0; font-weight: normal;"></span>
		      <i class="nav-icon fa fa-inbox"></i>
	    </button>
	    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop nav-messages" aria-labelledby="messages-menu-button" role="menu">
	      <div class="custom-drop-panel">
	        <div class="list-group messages-group">
	        <ng-container *ngIf="messages">
	          <div class="list-group-item pointMe"
	               *ngFor="let obj of messages; index as i"
	               (click)="openMessage(i)">
	            <div class="row" [ngClass]="{ 'message-unread': obj.read === false }">
	              <div class="col-xs-12 truncate">{{ obj.created }}</div>
	              <div class="col-xs-12 truncate"
	                   [class.hide]="obj.open"
	                   (click)="obj.action(obj.arg)">
	                		{{ obj.messageObj.message }}
	              </div>
	            </div>
	            <div class="row top-spacing" *ngIf="obj.open">
	              <div class="col-xs-12">{{ obj.messageObj.message }}</div>
	            </div>
	          </div>
	          </ng-container>
	          <div class="list-group-item" *ngIf="(messages?.length || 0)< 1">
	            <em>{{ LOCALIZATION.messagesEmpty }}</em>
	          </div>
	          <div class="list-group-item">
	            <button class="btn btn-primary" (click)="goToMode('profile','?tab=messages');closeDropdown(dropdownRef)"> 
	              {{ LOCALIZATION.messagesView }}
	            </button>
	          </div>
	        </div>
	      </div>
	    </ul>
	  </li>
	</ul>
	
	<!--// Help menu -->
	<ul class="help-information hidden-xs customNav">
	  <li class="dropdown" ngbDropdown #dropdownRef="ngbDropdown" autoClose="outside">
		<button
		  type="button"
		  id="help-menu-button"
		  ngbDropdownToggle
		  class="btn btn-link dropdown-toggle"
		  aria-expanded="false"
		  aria-haspopup="true"
		  [attr.aria-label]="LOCALIZATION.information"
		  title="{{ LOCALIZATION.information }}"
		  (click)="closeLiveAlerts()">
	      	<i class="nav-icon fa-solid fa-question-circle" aria-hidden="true"></i>
	    </button>
	    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop" aria-labelledby="help-menu-button" role="menu">
	      <li role="menuitem">
	        <a (click)="displayHelp(); closeDropdown(dropdownRef);">{{ LOCALIZATION.help }}</a>
	      </li>
	      <li role="menuitem">
	        <a (click)="goToMode('faq'); closeDropdown(dropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.faqs }}</a>
	      </li>
	      <li role="menuitem">
	        <a (click)="about(); closeDropdown(dropdownRef);">{{ LOCALIZATION.about }}</a>
	      </li>
	    </ul>
	  </li>
	</ul>
	
	<!--// Avatar menu -->
	<ul class="user-options customNav" *ngIf="user?.loggedin && !authenticationUIDisabled">
	  <li class="dropdown" ngbDropdown #dropdownRef="ngbDropdown" autoClose="outside">
		<button
		  type="button"
		  id="avatar-menu-button"
		  ngbDropdownToggle
		  class="btn btn-link dropdown-toggle"
		  aria-expanded="false"
		  aria-haspopup="true"
		  [attr.aria-label]="LOCALIZATION.userOptions"
		  title="{{ LOCALIZATION.userOptions }}"
		  (click)="closeLiveAlerts()">
	    	<i class="nav-icon fa fa-user" aria-hidden="true"></i>
	    </button>
	
	    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop" aria-labelledby="avatar-menu-button" role="menu">
	      <li role="menuitem" *ngIf="profileOn">
	        <a (click)="goToMode('profile'); closeDropdown(dropdownRef);">{{ LOCALIZATION.profile }}</a>
	      </li>
	
	      <li role="menuitem" *ngIf="user?.loggedin && !userPermissions['BLOCK_ADMIN_SITE']">
	        <a (click)="adminSite()">{{ LOCALIZATION.admin }}</a>
	      </li>
	
	      <ng-container *ngIf="themeSupported()">
	        <li role="menuitem" 	
	        	*ngIf="user?.loggedin && userPermissions['ROLE_INTERFACE_CUSTOMIZE']"
	        	class="hidden-xs">
	          		<a (click)="openThemeBuilder(); closeDropdown(dropdownRef);">{{ LOCALIZATION.themeBuilder }}</a>
	        </li>	      
	      	<li class="divider" role="separator"></li>
	        <li class="dropdown-header">{{ LOCALIZATION.theme }}</li>
	        <li role="menuitem">
	          <a (click)="setTheme(''); closeDropdown(dropdownRef);" title="Toggle Light theme">
	          	<i *ngIf="!user.theme" class="selected-theme fa fa-caret-right" aria-hidden="true"></i>
	          	Light
	          </a>
	        </li>
	        <li role="menuitem">
	          <a (click)="setTheme('dark'); closeDropdown(dropdownRef);" title="Toggle Dark theme">
	          	<i *ngIf="user?.theme === 'dark'" class="selected-theme fa fa-caret-right" aria-hidden="true"></i>
	          	Dark
	          </a>
	        </li>
	        <li role="menuitem">
	          <a (click)="setTheme('indigo'); closeDropdown(dropdownRef);" title="Toggle Indigo theme">
	          	<i *ngIf="user?.theme === 'indigo'" class="selected-theme fa fa-caret-right" aria-hidden="true"></i>
	          	Indigo
	          </a>
	        </li>
	        <li role="menuitem">
	          <a (click)="setTheme('2.0'); closeDropdown(dropdownRef);" title="Toggle 2.0 theme">
	          	<i *ngIf="user?.theme === '2.0'" class="selected-theme fa fa-caret-right" aria-hidden="true"></i>
	          	2.0
	          </a>
	        </li>
	        <li *ngFor="let theme of themes" role="menuitem">
	          <a (click)="setTheme(theme.name); closeDropdown(dropdownRef);" [title]="'Toggle ' + theme.label + ' theme'">
	          	<i *ngIf="user?.theme === theme.name" class="selected-theme fa fa-caret-right" aria-hidden="true"></i>
	          	{{ theme.label }}
	          </a>
	        </li>	        
	      </ng-container>
	
	      <li role="separator" class="divider"></li>
	
	      <li role="menuitem" *ngIf="!userPasswordDisabled">
	        <a (click)="logout()">{{ LOCALIZATION.logout }}</a>
	      </li>
	    </ul>
	  </li>
	</ul>
	<span *ngIf="user?.loggedin && !authenticationUIDisabled" class="user-info hidden-xs">
	  <span *ngIf="user?.firstName">{{ LOCALIZATION.welcome }}, </span>{{ user?.firstName }}
	</span>
	
	<!--// Login and register buttons -->
	<div *ngIf="!user?.loggedin" style="margin-top: 12px;" class="primary-controls">
	  <button *ngIf="!authenticationUIDisabled" 
	  	type="submit" 
	  	(click)="showLogin('login')" 
	  	class="btn btn-primary">
	   	    {{ LOCALIZATION.login }}
	  </button>
	  <button *ngIf="passwordEnabled && registerEnabled"
	    class="btn btn-primary"
	    (click)="showLogin('register')">
	    	{{ LOCALIZATION.register }}
	  </button>
	</div>
	
	<!--// Mobile menu -->
	<ul class="navbar-mobile-menu customNav visible-xs">
	  <li class="dropdown" ngbDropdown #mobileDropdownRef="ngbDropdown" [autoClose]="'outside'">
	    <a id="social-menu-mobile-button"
	      class="dropdown-toggle"
	      role="button"
	      aria-haspopup="true"
	      aria-expanded="false"
	      [attr.aria-label]="LOCALIZATION.menu"
	      (click)="closeLiveAlerts()"
	      ngbDropdownToggle
	      [attr.title]="LOCALIZATION.menu">
	      	<i class="nav-icon fa fa-bars" aria-hidden="true"></i>
	    </a>	
	    <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right custom-drop" aria-labelledby="social-menu-mobile-button" role="menu">
	      <li class="icon-container"
	          *ngIf="
	            socials?.x?.length > 0 || socials?.facebook?.length > 0 || socials?.youtube?.length > 0 ||
	            socials?.instagram?.length > 0 || socials?.linkedin?.length > 0"
	          role="menuitem">
	        <a *ngIf="socials?.x?.length > 0" target="_blank" [href]="socials.x" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkTwitter">
	        	<i class="social-icon fa-brands fa-x-twitter" aria-hidden="true"></i>
	        </a>
	        <a *ngIf="socials?.facebook?.length > 0" target="_blank" [href]="socials.facebook" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkFacebook">
	        	<i class="social-icon fa-brands fa-facebook" aria-hidden="true"></i>
	        </a>
	        <a *ngIf="socials?.youtube?.length > 0" target="_blank" [href]="socials.youtube" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkYoutube">
	        	<i class="social-icon fa-brands fa-youtube" aria-hidden="true"></i>
	        </a>
	        <a *ngIf="socials?.instagram?.length > 0" target="_blank" [href]="socials.instagram" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkInstagram">
	        	<i class="social-icon fa-brands fa-instagram" aria-hidden="true"></i>
	        </a>
	        <a *ngIf="socials?.linkedin?.length > 0" target="_blank" [href]="socials.linkedin" [title]="LOCALIZATION.goto + ' ' + LOCALIZATION.linkLinkedin">
	        	<i class="social-icon fa-brands fa-linkedin" aria-hidden="true"></i>
	        </a>
	      </li>
		  <li [ngStyle]="{ visibility: !isUserAllowedToSearch ? 'hidden' : 'visible' }"
		       role="menuitem"
		       routerLinkActive="active">
		      	<a (click)="goToMode('s'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.search }}</a>
		  </li>
	      <li *ngIf="user?.loggedin && upload" role="menuitem" routerLinkActive="active">
	        <a (click)="goToMode('upload'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.upload }}</a>
	      </li>
	      <li *ngIf="orderOn" role="menuitem" routerLinkActive="active">
	        <a (click)="goToMode('downloads'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.exportsDownloads }}</a>
	      </li>
	      <li *ngIf="user?.loggedin && (userPermissions['ROLE_NOTIFICATION_CREATE'] || userPermissions['ROLE_NOTIFICATION_MANAGEMENT'] || userPermissions['ROLE_NOTIFICATION_SUBSCRIBE'] || userPermissions['ROLE_NOTIFICATION_VIEW'])"
	          role="menuitem"
	          routerLinkActive="active">
	        <a (click)="goToMode('saved-searches'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.savedSearches }}</a>
	      </li>
	      <li *ngIf="user?.loggedin && albumOn" role="menuitem" routerLinkActive="active">
	        <a (click)="goToMode('albums'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.albums }}</a>
	      </li>
	      <li *ngIf="user?.loggedin && cartOn" role="menuitem" routerLinkActive="active">
	        <a (click)="goToMode('cart'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">Cart</a>
	      </li>
	      <li *ngIf="user?.loggedin && downloadOn" role="menuitem" routerLinkActive="active">
	        <a (click)="goToMode('purchases'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.purchases }}</a>
	      </li>
	      <li *ngIf="user?.loggedin && dxOn && (userPermissions['ROLE_DECLASS_BATCH_VIEW'] || userPermissions['ROLE_DECLASS_BATCH_MANAGE'] || userPermissions['ROLE_DECLASS_TASK_VIEW'] || userPermissions['ROLE_DECLASS_TASK_MANAGE'])"
	          role="menuitem"
	          routerLinkActive="active">
	        <a (click)="goToMode('dx'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.awdx }}</a>
	      </li>
	      <li *ngIf="user?.loggedin" role="menuitem">
	        <a (click)="goToMode('profile'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">
	          <span *ngIf="messagesCount" class="badge" [textContent]="messagesCount" style="position: absolute; right: 5px;"></span>
	          {{ LOCALIZATION.messages }}
	        </a>
	      </li>
	      <li role="menuitem"><a (click)="displayHelp(); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.help }}</a></li>
	      <li role="menuitem">
	        <a (click)="goToMode('faq'); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.faqs }}</a>
	      </li>
	      <li role="menuitem"><a (click)="about(); closeDropdown(mobileDropdownRef);" style="cursor: pointer;">{{ LOCALIZATION.about }}</a></li>
	    </ul>
	  </li>
	</ul>
 </div>
</div>
</nav>
